"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceDebrisCollection = void 0;
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var ResourceType_1 = require("../../../ResourceType");
var Tags_1 = require("../../Tags");
var OrOptions_1 = require("../../../inputs/OrOptions");
var SelectOption_1 = require("../../../inputs/SelectOption");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRequirements_1 = require("../../CardRequirements");
var SpaceDebrisCollection = (function (_super) {
    __extends(SpaceDebrisCollection, _super);
    function SpaceDebrisCollection() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SPACE_DEBRIS_COLLECTION,
            tags: [Tags_1.Tags.SPACE],
            cost: 10,
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 3).max(); }),
            metadata: {
                cardNumber: 'L417',
                description: 'Add 2 asteroids to this card.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 asteroid to this card.', function (eb) {
                        eb.empty().startAction.asteroids(1).nbsp.or();
                    }).br;
                    b.action('Spend 1 asteroid here to draw a card.', function (eb) {
                        eb.asteroids(1).startAction.cards(1);
                    }).br;
                    b.asteroids(2);
                }),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    SpaceDebrisCollection.prototype.canPlay = function (player) {
        return player.getTagCount(Tags_1.Tags.SCIENCE, false, false) <= 3;
    };
    SpaceDebrisCollection.prototype.play = function () {
        this.resourceCount = 2;
        return undefined;
    };
    SpaceDebrisCollection.prototype.canAct = function () {
        return true;
    };
    SpaceDebrisCollection.prototype.action = function (player) {
        var _this = this;
        var hasAsteroids = this.resourceCount > 0;
        var drawCardOption = new SelectOption_1.SelectOption('Remove 1 asteroid on this card to draw a card', 'Remove asteroid', function () {
            _this.resourceCount--;
            player.drawCard(1);
            return undefined;
        });
        var addAsteroidToSelf = new SelectOption_1.SelectOption('Add 1 asteroid to this card', 'Add asteroid', function () {
            player.addResourceTo(_this, { log: true });
            return undefined;
        });
        if (hasAsteroids) {
            return new OrOptions_1.OrOptions(drawCardOption, addAsteroidToSelf);
        }
        else {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
    };
    return SpaceDebrisCollection;
}(Card_1.Card));
exports.SpaceDebrisCollection = SpaceDebrisCollection;
//# sourceMappingURL=SpaceDebrisCollection.js.map